import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class ReportApi {
  static async GenerateFailuresByOperation(payload: {
    plantId: string;
    productionUnitId: string;
    areaId: string;
    lineId: string;
    sublineId: string;
    productId: string;
    fmeaId: string;
  }): Promise<any> {
    return ApiHandler(baseURL).post("/reports/failures-by-operation", payload, {
      responseType: "blob",
    });
  }
}
